"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LN10Dependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var LN10Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createLN10: _factoriesAny.createLN10
};
exports.LN10Dependencies = LN10Dependencies;